/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_Li5_TextInputs */

const tr_onbilgi_s10_li5_text = /** @type {(inputs: Onbilgi_S10_Li5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veritabanı yedekleri günlük olarak alınır; Supabase eu-west-1 bölgesinde 7 günlük noktasal kurtarma (PITR) desteği aktiftir.`)
};

const en_onbilgi_s10_li5_text = /** @type {(inputs: Onbilgi_S10_Li5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database backups are taken daily; 7 day point in time recovery (PITR) support is active in the Supabase eu-west-1 region.`)
};

const de_onbilgi_s10_li5_text = /** @type {(inputs: Onbilgi_S10_Li5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenbanksicherungen werden täglich erstellt; in der Region Supabase eu-west-1 ist eine 7-tägige punktgenaue Wiederherstellung (PITR) aktiv.`)
};

const ru_onbilgi_s10_li5_text = /** @type {(inputs: Onbilgi_S10_Li5_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резервные копии базы данных создаются ежедневно; в регионе Supabase eu-west-1 активна поддержка восстановления на момент времени (PITR) за 7 дней.`)
};

/**
* | output |
* | --- |
* | "Database backups are taken daily; 7 day point in time recovery (PITR) support is active in the Supabase eu-west-1 region." |
*
* @param {Onbilgi_S10_Li5_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_li5_text = /** @type {((inputs?: Onbilgi_S10_Li5_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_Li5_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_li5_text(inputs)
	if (locale === "de") return de_onbilgi_s10_li5_text(inputs)
	if (locale === "ru") return ru_onbilgi_s10_li5_text(inputs)
	return tr_onbilgi_s10_li5_text(inputs)
});